import { InjectionToken } from '@angular/core';

export interface NotificationDetailsTitleHandler {
  setDetailTitle(entity: string, payload?: any): void;
}

export const NOTIFICATION_DETAILS_TITLE_HANDLER =
  new InjectionToken<NotificationDetailsTitleHandler>(
    'NOTIFICATION_DETAILS_TITLE_HANDLER'
  );
